import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const LockSVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default LockSVG;
